import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { IProject } from "Model/Storage/IProject";
import { projectsUpdateStart } from "Store/Actions";
import { selectSelectedOrActiveProjects } from "Store/Selectors/Projects";
import { hasElements } from "Utils/Array";
import { isNullOrWhiteSpace } from "Utils/String";
import { IAction } from "./IAction";

export function useAssignMe(): [boolean, IAction] {
  const dispatch = useDispatch();
  const { preflightAuthentication } = useAuthenticationPreflight();
  const { accounts } = useMsal();
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const allowAssignMe = hasElements(selectedProjects) && selectedProjects.length <= 10;

  const onAssignMe = useCallback(async () => {
    if (!allowAssignMe) {
      return;
    }

    const userName = accounts?.[0]?.username ?? `Unknown User`;
    if (isNullOrWhiteSpace(userName)) {
      return;
    }
    const displayName = accounts?.[0]?.name ?? userName;

    const updateProjectsList: IProject[] = [];
    for (const project of selectedProjects) {
      const userList = project[`@users`] ?? [];
      const hasUser = userList.some(({ name }) => name === userName);
      if (hasUser) {
        continue;
      }

      updateProjectsList.push({
        ...project,
        "@users": [...userList, { name: userName, displayName }]
      });
    }

    if (updateProjectsList.length <= 0) {
      return;
    }

    await preflightAuthentication();
    dispatch(projectsUpdateStart(updateProjectsList));
  }, [accounts, allowAssignMe, dispatch, preflightAuthentication, selectedProjects]);

  return [allowAssignMe, onAssignMe];
}
